import React, { Autocomplete, Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Collapser } from 'components';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { SalesFilterPaneProps } from './SaleFilterPaneProps';
import { useAuth, usePartners, useProducts, useUsers } from 'hooks';

export const SalesFilterPane = ({ filterData, setData }: SalesFilterPaneProps) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const { isAdministrator } = useAuth();
	const { partners } = usePartners();
	const { users } = useUsers();
	const { products } = useProducts();
	return (
		<Paper sx={{ p: 5 }}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={5}>
							<DatePicker
								sx={{ width: '100%' }}
								value={dayjs(filterData.startDate)}
								label='Date from'
								maxDate={dayjs(filterData.endDate)}
								onChange={value => setData({ ...filterData, startDate: value?.toDate() })}
								slotProps={{ textField: { size: 'small' } }}
							/>
						</Grid>
						<Grid item xs={1} textAlign={'center'} alignSelf={'end'}>
							<Typography variant='h4'>-</Typography>
						</Grid>
						<Grid item xs={5}>
							<DatePicker
								sx={{ width: '100%' }}
								value={dayjs(filterData.endDate)}
								label='Date to'
								minDate={dayjs(filterData.startDate)}
								onChange={value => setData({ ...filterData, endDate: value?.toDate() })}
								slotProps={{ textField: { size: 'small' } }}
							/>
						</Grid>
						<Grid item xs={1} textAlign={'center'} alignSelf={'end'}>
							<Button onClick={() => setIsExpanded(!isExpanded)}>
								<Collapser isAdd={false} open={isExpanded} />
							</Button>
						</Grid>
					</Grid>
				</Grid>
				{isExpanded && (
					<>
						{isAdministrator && (
							<>
								<Grid item xs={12}>
									<Grid container>
										<Grid item xs={12}>
											<Autocomplete
												options={partners || []}
												getOptionLabel={option => option.firstName + ' ' + option.lastName}
												value={partners?.find(partner => partner.id === filterData.partnerId) ?? null}
												onChange={(_, value) => setData({ ...filterData, partnerId: value?.id ?? 0 })}
												renderInput={params => <TextField {...params} label='Partner' size='small' />}
											/>
										</Grid>
									</Grid>
								</Grid>
							</>
						)}
						<Grid item xs={12}>
							<Autocomplete
								options={users || []}
								getOptionLabel={option => option.firstName + ' ' + option.lastName}
								value={users?.find(user => user.id === filterData.userId) ?? null}
								onChange={(_, value) => setData({ ...filterData, userId: value?.id ?? 0 })}
								renderInput={params => <TextField label='Customer' {...params} size='small' />}
							/>
						</Grid>
						<Grid item xs={12}>
							<Autocomplete
								options={products || []}
								getOptionLabel={option => option.name}
								value={products?.find(customer => customer.id === filterData.productId) ?? null}
								onChange={(_, value) => setData({ ...filterData, productId: value?.id ?? 0 })}
								renderInput={params => <TextField label='Product' {...params} size='small' />}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
}
